import script from "./ConnectedTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedTickets.vue?vue&type=script&setup=true&lang=js"

import "./ConnectedTickets.vue?vue&type=style&index=0&id=80ea4836&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80ea4836"]])

export default __exports__